import vipapi from './vipAPI'

// 获取url信息
function getcommit(name) {
	return (
		decodeURIComponent(
			(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
				location.href
			) || ["", ""])[1].replace(/\+/g, "%20")
		) || false
	);
}
// 获取token

// if (getcommit('token')) {
//     sessionStorage.setItem('token', getcommit('token'))
// }
// token = sessionStorage.getItem('token') || ''
// 获取设备信息
let statistics
if (getcommit('statistics')) {
	sessionStorage.setItem('statistics', getcommit('statistics'))
}
statistics = sessionStorage.getItem('statistics')


// 获取url上的id
// 获取url上的type
// 判断手机系统

//判断访问终端
var browser = {
	versions: function() {
		var u = navigator.userAgent;
		return {
			trident: u.indexOf('Trident') > -1, //IE内核
			presto: u.indexOf('Presto') > -1, //opera内核
			webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
			gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
			mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
			ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
			android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
			iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
			iPad: u.indexOf('Mac OS') > -1, //是否iPad
			webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
			weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
			qq: u.match(/\sQQ/i) == " qq" //是否QQ
		};
	}(),
	language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
let isIOS = browser.versions.ios || browser.versions.iPad
// 获取url上isVerify处理游客模式
let isVerify = getcommit('isVerify')

//  保存，用于导出
const CONFIG = {
	isVerify,
	statistics,
	isIOS
}

// 域名获取
function convertDomain(currDomain) {
	var localDomain = window.location.host
	var name = localDomain.split('.', 2)[0]
	var arr = name.split('-', 2)
	return arr.length > 1 ? arr[0] + '-' + currDomain : "" + currDomain
}

// 进行配置
let address = 'https://' + convertDomain('rest.zhibo.tv')
let address2 = 'https://' + convertDomain('vip.zhibo.tv')
let address3 = 'https://' + convertDomain('static.zhibo.tv')
let address4 = 'http://' + convertDomain('vip.zhibo.tv')
// let address = 'https://' + convertDomain('t100-rest.zhibo.tv')
// let address2 = 'https://' + convertDomain('t100-vip.zhibo.tv')
// let address3 = 'https://' + convertDomain('t100-static.zhibo.tv')
// let address4 = 'http://' + convertDomain('t100-vip.zhibo.tv')
const ADDRESS = {
	address,
	address2,
	address3,
	address4
}
export {
	CONFIG,
	ADDRESS,
	vipapi
}
